import React from 'react'
import { ArticleCardBlocks } from 'experiences/learn/articles/ArticleCard/types'

import { SEOLink } from 'components/elements/links/SEOLink'
import {
	CardBody,
	CardBottom,
	CardBottomText,
	CardText,
	CardTitle,
	ImageContainer,
	Topic
} from 'experiences/learn/articles/ArticleCard/styles/Base.style'

export const ArticleCardLayout: React.FC<React.PropsWithChildren<ArticleCardBlocks>> = ({
	image,
	topic,
	title,
	description,
	readingTime,
	favoriteIcon,
	RootComponent,
	href
}) => {
	return (
		<SEOLink href={href}>
			<RootComponent>
				<ImageContainer>{image}</ImageContainer>
				<CardBody>
					<Topic>{topic}</Topic>
					<CardTitle lineCount={3} lineHeight={1.5}>
						{title}
					</CardTitle>
					<CardText lineCount={4} lineHeight={1.4}>
						{description}
					</CardText>
					<CardBottom>
						<CardBottomText>{readingTime}</CardBottomText>
						{favoriteIcon}
					</CardBottom>
				</CardBody>
			</RootComponent>
		</SEOLink>
	)
}
